import { EditRelocationDetail } from './relocation-detail.interface';
import { initialStateEditOrderDetail } from 'app/core/store/order-detail/order-detail.model';
import { initialStateEditFlorderDetail, initialStateRelocationDetail, initialStateRelocationPlanning, } from 'app/core/store/edit-florder-detail/florder-detail.model';

export const initialStateEditRelocationDetail: EditRelocationDetail = Object.assign({}, initialStateEditFlorderDetail, {
  mode: {
    ...initialStateEditOrderDetail.mode,
    type: 'relocation',
  },
  relocationDetail: initialStateRelocationDetail,
  planning: initialStateRelocationPlanning,
  availableLoadingDates: {
    loading: false,
    loaded: false,
    from: [],
    to: [],
  },
  materialsState: {
    loading: false,
    loadSuccess: false,
    loadFailed: false,
    data: {
      combination: {
        palletIds: [],
      },
      packings: [],
      pallets: [],
    },
  },
});
